var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.number !== ',')?_c('img',{attrs:{"src":_vm.$filterImgSrc('/header/number/' + _vm.number + '.svg'),"alt":_vm.number}}):_c('img',{attrs:{"src":_vm.$filterImgSrc('/header/number/comma1.svg'),"alt":_vm.number}})}
var staticRenderFns = []

export { render, staticRenderFns }